import { render, staticRenderFns } from "./KBtnToggle.vue?vue&type=template&id=02a48f27"
import script from "./KBtnToggle.vue?vue&type=script&lang=js"
export * from "./KBtnToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtnToggle})
